<template>
  <div class="box">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      @load="onLoad"
      class="wrapper"
      >
      <div class="main">
        <div class="statistics line_bottom">
          <div class="title">{{taskInfoData.taskName}}</div>
          <div class="completionDate" v-show="taskInfoData.endTime">目标完成日期：{{taskInfoData.endTime|filtTime1}}</div>
          <div class="approvalStatus">
            <div class="mode" :class="{closeColor: taskInfoData.auditStatusName=='已关闭'}">{{taskInfoData.auditStatusName}}</div>
            <div class="review" @click="handleShowExaminePop" v-if="taskInfoData.showAudit">审核</div>
          </div>
        </div>
        <div class="dataListBox">
          <div class="dataListNav">
            <div
              class="dataListNavItem"
              v-for="(item, index) in dataListNavList"
              :key="index"
              :class="{'active':isDlNavItem === index}"
              @click="handleDlNavItemActive(index)"
            >{{item.name}}</div>
          </div>
          <div class="choiceIndustryBox" v-if="isDlNavItem === 0">
            <div class="choiceIndustryBtn" @click="handleChoiceIndustryPop">
              <span class="choiceIndustryBtnText">{{industryText.text}}</span>
              <div class="choiceIndustryBtnIcon">
                <img src="../../../../assets/image/xiala.png" />
              </div>
            </div>
            <div class="allListCounts">共{{workOrderPageTotal}}个工单</div>
          </div>
          <!-- 评分对象列表 -->
          <div class="scoreObjectList" v-if="isDlNavItem === 0">

              <div class="scoreObjectListItem" :class="{scoreObjectListItemList: (index+ 1) === workOrderPageList.length}" v-for="(item,index) in workOrderPageList" :key="index">
                <p class="scoreObjectId">工单ID:{{item.workOrderId}}</p>
                <div class="scoreObjectNameBox" @click="toPageDetailOrders(item)">
                  <div class="scoreObjectName">{{item.enterpriseName}}</div>
                  <div class="scoreObjectTo">
                    <span>{{item.result}}</span>
                    <div>
                      <img src="../../../../assets/image/t-right.png" />
                      <!-- <img src="../../../../assets/image/ic_gb@2x.png" alt=""> -->
                    </div>
                  </div>
                </div>
                <div class="scoreObjectBages">
                  <div class="locationBage line_border_blue">{{item.regionName}}</div>
                  <div class="industryBage line_border_green">{{item.industryCategoryName}}</div>
                </div>
              </div>

          </div>
          <!-- 任务信息列表 -->
          <div class="taskDetailList" v-if="isDlNavItem === 1">
            <div class="taskDetailListItem">
              <div class="taskDetailTitle">创建时间:</div>
              <p v-show='taskInfoData.createTime'>{{taskInfoData.createTime|filtTime}}</p>
            </div>
            <div class="taskDetailListItem">
              <div class="taskDetailTitle">受委托方:</div>
              <p>{{taskInfoData.unitName}}</p>
            </div>
            <div class="taskDetailListItem">
              <div class="taskDetailTitle">涉及行业类别:</div>
              <p>{{taskInfoData.industryCategory}}</p>
            </div>
            <div class="taskDetailListItem">
              <div class="taskDetailTitle">任务描述:</div>
              <p>{{taskInfoData.memo}}</p>
            </div>
          </div>
          <!-- 操作记录列表 -->
        </div>

        <common-picker
          ref="isShowIndustryPop"
          :typeList="industryList"
          :cols="cols1"
          @getTypeValue="getTypeValue"
        ></common-picker>
        <van-popup
          class="examinePicker"
          v-model="isShowExaminePicker"
          position="bottom"
          closeable
          @close="retunThroughExamineActive"
          :style="{ minHeight: '232px'}"
        >
          <h5 class="examinePickerTitle">审核结果</h5>
          <div class="examineBtns">
            <div
              class="throughExamine"
              :class="{'active': isThroughExamine}"
              @click="changeThroughExamine"
            >通过</div>
            <div
              class="notThroughExamine"
              :class="{'active': isNotThroughExamine}"
              @click="changeNotThroughExamine"
            >不通过</div>
          </div>
          <div class="examineMiddleBox">
            <div class="examineOpinionBox" v-show="isThroughExamine">
              <van-checkbox v-model="checked" checked-color="#07c160">填写审核意见</van-checkbox>
            </div>
            <div class="notThroughExamineTitile" v-show="isNotThroughExamine">
              审核意见
              <span>必填</span>
            </div>
            <div v-show="checked" class="throughExamineTextBox">
              <!-- <van-field
                class="throughExamineText"
                v-model="throughExamineText"
                type="textarea"
                placeholder="请在这里输入您的审核意⻅"
              />-->
              <textarea
                name
                class="throughExamineText"
                placeholder="请在这里输入您的审核意⻅"
                v-model="throughExamineText"
                @blur="loseBlur"
                maxlength="120"
              >
             </textarea>
            </div>
          </div>
          <div
            class="submitBtn"
            :class="{'active': isThroughExamine || isNotThroughExamine}"
            @click="handleSubmitExamine"
          >提交</div>
        </van-popup>
        <!-- <transition name="fade">
          <div class="examineDetailTipsBox" transition="fade" v-show="examineDetailTips">
            <img src="../../../../assets/image/icon_ts_tg.png" v-if="tipsIcon" />
            <img src="../../../../assets/image/icon_ts_gx.png" v-if="!tipsIcon" />
            <p>{{tipsIcon?'审核通过':'审核不通过'}}</p>
          </div>
        </transition> -->
      </div>
    </van-list>
  </div>
</template>
<script>
    import commonPicker from '../../../../components/base/commonPicker';
    import api from '../../../../service/modules/integrity';
    import apimessage from '../../../../service/modules/message'
    export default {
        components: {
            commonPicker
        },
        data () {
            return {
                finishedText: '',
                loading: false,
                finished: false,
                pageIndex: 1,
                pageSize: 10,
                active: '',
                // 展示全部审查文本
                isShowAllExamineText: false,
                // 是否通过审核
                throughExamine: false,
                isDlNavItem: 0,
                dataListNavList: [
                    { name: '评分对象', isShow: true },
                    { name: '任务信息', isShow: true }
                ],
                // 行业标签
                industryText: { text: '全部行业', type: '' },
                // 选择行业弹窗List
                industryList: [],
                cols1: 1,
                // 审核Picker弹出层
                isShowExaminePicker: false,
                isThroughExamine: false,
                isNotThroughExamine: false,
                checked: false,
                throughExamineText: '',
                // 提交按钮提交完的tip状态
                examineDetailTips: '',
                tipsIcon: true,
                taskId: '',
                industryCategory: '', // 行业类别
                workOrderPageList: [], // 评分对象列表
                workOrderPageTotal: '', // 评分列表数量
                taskInfoData: {} // 任务信息
            };
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            this.taskId = this.$route.query.taskId;
            this.id = this.$route.query.id;
            this.handleList();
            this.getworkOrderPage();
            this.getindustryCategory();
        },
        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            onLoad () {
                this.pageIndex++
                this.getworkOrderPage()
            },
            // 获取行业分类信息
            getindustryCategory () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        this.industryList = [];
                        let arr = res.data.map(({ name, code }) => {
                            return {
                                text: name,
                                value: code,
                                type: code
                            };
                        });
                        let first = [{ text: '全部行业', type: '' }];
                        this.industryList.push([...first, ...arr]);
                    }
                });
            },
            // 任务信息
            handleList () {
                let parm = {
                    taskId: this.taskId
                };
                api.taskInfo(parm).then(res => {
                    console.log(res.data);
                    res.data.industryCategory = res.data.industryCategory.substr(1);
                    res.data.industryCategory = res.data.industryCategory.substr(
                        0,
                        res.data.industryCategory.length - 1
                    );
                    this.taskInfoData = res.data;
                });
            },
            // 评分对象
            getworkOrderPage () {
                let parm = {
                    taskId: this.taskId,
                    industryCategory: this.industryCategory,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                };
                api.workOrderPage(parm).then(res => {
                    if (res.ret === 0) {
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.workOrderPageList = this.workOrderPageList.concat(arr)
                            this.finished = false
                            if (arr.length < 10) {
                                this.finished = true
                                this.finishedText = '没有更多了'
                            }
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                        // this.workOrderPageList = res.data.list;
                        this.workOrderPageTotal = res.data.pageination.total;
                    }
                });
            },
            toPageDetailOrders (item) {
                this.$router.push({
                    path: 'workOrder',
                    query: { enterpriseId: item.workOrderId }
                });
            },
            // 数据列表导航状态切换
            handleDlNavItemActive (index) {
                this.isDlNavItem = index;
                if (index === 0) {
                    this.finishedText = '没有更多了'
                } else {
                    this.finishedText = ''
                }
            },
            // 选择行业弹窗事件
            handleChoiceIndustryPop () {
                this.$refs.isShowIndustryPop.showPicker();
            },
            getTypeValue (data) {
                this.workOrderPageList = []
                this.pageIndex = 1
                this.industryText.text = data[0].text;
                this.industryCategory = data[0].type;
                this.getworkOrderPage();
            },
            // 审核弹窗事件
            handleShowExaminePop () {
                this.isShowExaminePicker = true;
            },
            // 通过按钮事件
            changeThroughExamine () {
                this.isThroughExamine = true;
                this.isNotThroughExamine = false;
            },
            // 不通过按钮事件
            changeNotThroughExamine () {
                this.checked = true;
                this.isThroughExamine = false;
                this.isNotThroughExamine = true;
            },
            // 弹窗消失按钮状态取消
            retunThroughExamineActive () {
                this.checked = false
                this.isThroughExamine = false;
                this.isNotThroughExamine = false;
            },
            // 审核提交按钮事件
            handleSubmitExamine () {
                if (
                    this.isThroughExamine &&
                    this.checked &&
                    this.throughExamineText.trim() !== ''
                ) {
                    let parm = {
                        taskId: this.taskId,
                        reason: this.throughExamineText
                    };
                    api.auditPass(parm).then(res => {
                        if (res.ret === 0) {
                            this.isShowExaminePicker = false;
                            this.isThroughExamine = false;
                            this.checked = false;
                            this.throughExamineText = '';
                            this.examineDetailTips = true;
                            this.$Toast({
                                message: '审核通过',
                                icon: 'passed'
                            });
                            this.$router.replace({
                                path: 'auditPass',
                                query: { taskId: this.taskId, id: this.id }
                            });
                        }
                    });
                } else if (this.isThroughExamine && !this.checked) {
                    let parm = {
                        taskId: this.taskId,
                        reason: ''
                    };
                    api.auditPass(parm).then(res => {
                        if (res.ret === 0) {
                            this.isShowExaminePicker = false;
                            this.isThroughExamine = false;
                            this.checked = false;
                            this.throughExamineText = '';
                            this.examineDetailTips = true;
                            this.$Toast({
                                message: '审核通过',
                                icon: 'passed'
                            });
                            this.$router.replace({
                                path: 'auditPass',
                                query: {
                                    taskId: this.taskId,
                                    id: this.id
                                }
                            });
                        }
                    });
                } else if (
                    this.isThroughExamine &&
                    this.checked &&
                    this.throughExamineText.trim() == ''
                ) {
                    this.$Toast('请填写审核内容');
                } else if (
                    this.isNotThroughExamine &&
                    this.throughExamineText.trim() !== ''
                ) {
                    let parm = {
                        taskId: this.taskId,
                        reason: this.throughExamineText
                    };
                    api.auditRejected(parm).then(res => {
                        if (res.ret === 0) {
                            this.isShowExaminePicker = false;
                            this.isNotThroughExamine = false;
                            this.checked = false;
                            this.throughExamineText = '';
                            this.examineDetailTips = false;
                            this.$Toast({
                                message: '审核不通过',
                                icon: 'close'
                            });
                            this.$router.replace({
                                path: 'auditFailed',
                                query: {
                                    taskId: this.taskId,
                                    id: this.id
                                }
                            });
                        }
                    });
                } else if (
                    this.isNotThroughExamine &&
                    this.throughExamineText.trim() == ''
                ) {
                    this.$Toast('请填写审核意见');
                }
            },
            loseBlur () {
                window.scroll(0, 0)
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            filtTime1 (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D;
                return strDate;
            }
        }
    };
</script>
<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  color: #333;
}
.box {
  width: 100%;
  height: 100%;
  padding: 20px 12px 0 12px;
  box-sizing: border-box;
  background-color: #fbfbfb;

  .main {
    width: 100%;
    background-color: #fff;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;

    .statistics {
      width: 100%;
      // height: 137px;
      padding: 16px;
      box-sizing: border-box;

      .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
      }

      .completionDate {
        color: #999;
        font-size: 14px;
        margin-top: 8px;
      }

      .approvalStatus {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .mode {
          font-size: 14px;
          color: #ff8c19;
          line-height: 28px;
        }
        .closeColor{
         font-size: 14px;
          color: #999;
          line-height: 28px;
        }

        .mode2 {
          font-size: 14px;
          color: #36b374;
          line-height: 28px;
        }

        .mode3 {
          font-size: 14px;
          color: #ff4d4d;
          line-height: 28px;
        }

        .review {
          width: 64px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-size: 12px;
          background-color: #36b374;
          color: #fff;
          border-radius: 2px;
        }

        .seeTheExamineText::after {
          content: "";
          display: block;
          clear: both;
        }

        .seeTheExamineText {
          > span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333;
            line-height: 28px;
            float: left;
          }

          .theExamineTextIcom {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            float: left;

            > img {
              width: 100%;
              height: 100%;
              position: relative;
              top: 8px;
            }
          }
        }
      }

      .theExamineTextBox {
        padding: 8px 12px 4px;
        background-color: #f8f8f8;
        border-radius: 3px;

        > p {
          min-height: 76px;
          font-size: 12px;
          line-height: 20px;
        }

        > p.showSome {
          height: 76px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }

        .showAllExamineTextBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .showAllExamineTextBtn {
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: bold;
          text-align: center;
          line-height: 20px;
          color: #333;

          .showAllExamineTextIcon {
            width: 6px;
            height: 4px;
            margin-left: 4px;
            display: inline-block;
            position: relative;
            top: -2px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .dataListBox {
      padding: 16px 16px 12px 16px;
      background-color: #fff;

      .dataListNav::after {
        content: "";
        display: block;
        clear: both;
      }

      .dataListNav {
        margin-bottom: 16px;

        .dataListNavItem {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          line-height: 26px;
          color: #333;
          border-bottom: 2px solid transparent;
          float: left;
        }

        .dataListNavItem.active {
          color: #36b374;
          font-weight: 500;
          border-bottom-color: #36b374;
        }
      }

      .choiceIndustryBox::after {
        content: "";
        display: block;
        clear: both;
      }

      .choiceIndustryBox {
        margin-bottom: 20px;
        padding: 8px 0 0;

        .choiceIndustryBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .choiceIndustryBtn {
          font-size: 14px;
          font-weight: bold;
          line-height: 14px;
          text-align: center;
          color: #333;
          float: left;

          .choiceIndustryBtnText {
            margin-right: 5px;
            float: left;
          }

          .choiceIndustryBtnIcon {
            width: 6px;
            height: 4px;
            float: left;
            position: relative;
            top: 5px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .allListCounts {
          font-size: 12px;
          line-height: 14px;
          color: #999;
          float: right;
        }
      }
      .scoreObjectList {
        .scoreObjectListItem {
          margin-bottom: 18px;
          .scoreObjectId {
            font-size: 12px;
            line-height: 20px;
            color: #999999;
          }

          .scoreObjectNameBox::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectNameBox {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            .scoreObjectName {
              font-weight: 600;
              width: 210px;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #333;
              white-space: nowrap;
              float: left;
            }

            .scoreObjectTo::after {
              content: "";
              display: block;
              clear: both;
            }

            .scoreObjectTo {
              float: right;

              > span {
                margin-right: 4px;
                line-height: 22px;
                color: #999;
                float: left;
              }

              > div {
                width: 12px;
                height: 12px;
                line-height: 12px;
                float: left;
                position: relative;
                top: 5px;

                > img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }

          .scoreObjectBages::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectBages {
            margin-top: 2px;
            padding: 4px 0;

            .locationBage {
              padding: 0px 2px 2px 2px;
              margin-right: 8px;
              font-size: 10px;
              line-height: 16px;
              color: #2283e6;
              float: left;
            }

            .industryBage {
              padding: 0px 2px 2px 2px;
              font-size: 10px;
              line-height: 16px;
              color: #36b374;
              float: left;
            }
          }
        }
        .scoreObjectListItemList{
          margin-bottom: 0;
        }
      }

      .taskDetailList {
          padding-bottom: 16px;
        .taskDetailListItem::after {
          content: "";
          display: block;
          clear: both;
        }

        .taskDetailListItem {
          padding: 4px 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          // overflow: hidden;
          .taskDetailTitle {
            width: 96px;
            color: #999;
            float: left;
          }

          > p {
            margin-left: 96px;
          }
        }
      }

      .operationRecordList {
        .operationListItem:first-child {
          color: #333;

          .timePoint {
            border-color: #36b374;
          }
        }

        .operationListItem:last-child {
          border-color:#fff;
        }

        .operationListItem {
          padding: 0 15px 30px 18px;
          color: #999;
          border-left: 1px solid #eaeaea;
          position: relative;

          .operationTitle {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: bold;
          }

          .operationTime {
            margin-bottom: 8px;
            font-size: 12px;
          }

          .operaterBox {
            font-size: 12px;
            line-height:16px;
          }

          .operationDetail {
            font-size: 12px;
            line-height: 16px;
          }

          .timePoint {
            width: 13px;
            height: 13px;
            background-color: #fff;
            border: 1px solid #eaeaea;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: -8px;
          }
        }
      }
    }

    .examinePicker {
      padding: 12px;
      .examinePickerTitle {
        padding: 8px 4px 0 4px;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
      }

      .examineBtns::after {
        content: "";
        display: block;
        clear: both;
      }

      .examineBtns {
        padding: 0 4px;
        margin-bottom: 24px;

        > div {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #36b374;
          border: 1px solid #36b374;
          border-radius: 2px;
          float: left;
        }

        > div.active {
          color: #fff;
          background-color: #36b374;
        }

        .throughExamine {
          margin-right: 12px;
        }
      }

      .examineMiddleBox {
        min-height: 75px;
        padding: 0 4px;
        .examineOpinionBox {
          margin-bottom: 16px;
          font-size: 14px;
          color: #666;
        }

        .notThroughExamineTitile {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;

          > span {
            margin-left: 4px;
            font-size: 12px;
            font-weight: normal;
            color: #999;
          }
        }
        .throughExamineTextBox {
          margin-bottom: 24px;
          position:relative;
          .throughExamineText {
            margin-top: 10px;
            padding: 10px;
            height: 120px;
            border:none;
           resize: none;
            width: 94%;
            // overflow-y: scroll;
            font-size: 14px;
            line-height: 22px;
            color: #333333;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
        }
      }

      .submitBtn {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #9bd9ba;
        border-radius: 3px;
        font-size: 16px;
        font-weight: 500;
      }

      .submitBtn.active {
        background-color: #36b374;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .examineDetailTipsBox {
      width: 120px;
      height: 124px;
      padding: 24px 0 0 0;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.7);
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      > img {
        width: 50px;
        height: 50px;
        margin: 0 auto 12px;
        display: block;
      }

      > p {
        text-align: center;
        color: #fff;
      }
    }
  }
}
</style>

<style lang="less">
.van-overlay{
  background-color: rgba(0,0,0,.3);
}
</style>
